import { __decorate } from "tslib";
import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";
import { map } from "rxjs/operators";
import { HttpClient } from "@angular/common/http";
import { AppControllerService } from "../../../app-controller.service";
import { ApiLookupConstants } from "../../constants/api-constants/api-lookup.constants";
import { ApiPropertyValuationValuationBlockConstants } from "../../constants/api-constants/api-property-valuation-valuation-block.constants";
import { ApiPropertyValuationPropertyConstants } from "../../constants/api-constants/api-property-valuation-proprety.constants";
import { ApiPropertyValuationPropertyObjection } from "../../constants/api-constants/api-property-valuation-property-objection.constant";
import { ApiPropertyValuationValuationPropertyAppealConstants } from "../../constants/api-constants/api-property-valuation-property-appeal";
let PropertyValuationService = class PropertyValuationService {
    http;
    appControllerService;
    defaultAttributesOptions = new BehaviorSubject([]);
    requiredAttributesLoadStarted = new BehaviorSubject(false);
    constructor(http, appControllerService) {
        this.http = http;
        this.appControllerService = appControllerService;
    }
    getApplicationSetPropertiesObservable(applicationId, params) {
        return this.http.post(`${ApiPropertyValuationValuationBlockConstants.URL}/${applicationId}/`, params)
            .pipe(map((response) => {
            return response;
        }));
    }
    getLookupsObservable(params) {
        return this.http.get(ApiLookupConstants.URL, { params }).pipe(map(lookups => {
            return lookups;
        }));
    }
    patchApplication(app, id) {
        return this.http.patch(`${ApiPropertyValuationValuationBlockConstants.URL}/${id}`, app);
    }
    setHybridMethods(obj, id) {
        return this.http.post(`${ApiPropertyValuationValuationBlockConstants.URL}/${id}/${ApiPropertyValuationValuationBlockConstants.FUNCTION_SET_HYBRID_METHODS}`, obj);
    }
    setValuationBlockPropertiesProperties(obj, id) {
        return this.http.post(`${ApiPropertyValuationValuationBlockConstants.URL}/${id}/${ApiPropertyValuationValuationBlockConstants.FUNCTION_SET_VALUATION_BLOCK_PROPERTIES_PROPERTIES}`, obj);
    }
    setSalesArea(obj, id) {
        return this.http.post(`${ApiPropertyValuationValuationBlockConstants.URL}/${id}/${ApiPropertyValuationValuationBlockConstants.FUNCTION_SET_SALES_AREA}`, obj);
    }
    patchPvProprety(id, obj) {
        return this.http.patch(`${ApiPropertyValuationPropertyConstants.URL}/${id}`, obj);
    }
    postPvProprety(obj) {
        return this.http.post(`${ApiPropertyValuationPropertyConstants.URL}`, obj);
    }
    deletePvProprety(id) {
        return this.http.delete(`${ApiPropertyValuationPropertyConstants.URL}/${id}`);
    }
    getProperties(params) {
        return this.http.get(ApiPropertyValuationPropertyConstants.URL, { params }).pipe(map(data => {
            return data.value;
        }));
    }
    getPropertiesObjections(params) {
        return this.http.get(ApiPropertyValuationPropertyObjection.URL, { params }).pipe(map(data => {
            return data.value;
        }));
    }
    getPropertiesApeals(params) {
        return this.http.get(ApiPropertyValuationValuationPropertyAppealConstants.URL, { params }).pipe(map(data => {
            return data.value;
        }));
    }
    postPvPropretySetOwners(key, obj) {
        return this.http.post(`${ApiPropertyValuationPropertyConstants.URL}/${key}/${ApiPropertyValuationPropertyConstants.FUNCTION_SET_OWNERS}`, obj);
    }
    static ctorParameters = () => [
        { type: HttpClient },
        { type: AppControllerService }
    ];
};
PropertyValuationService = __decorate([
    Injectable({
        providedIn: "root"
    })
], PropertyValuationService);
export { PropertyValuationService };
